import { create } from "zustand";

export interface DeviceInfoDto {
  processor_id: string;
  mac_address: string;
  name: string;
  os: string;
  platform: string;
}

export interface DeviceDto {
  id: number;
  device_info: DeviceInfoDto;
  session_id: string | null;
  created_at: string;
  is_active: boolean;
}

export interface DevicesState {
  devices: DeviceDto[];
  loading: boolean;
  error: string | null;
}

interface DevicesActions {
  setDevices: (devices: DeviceDto[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearDevices: () => void;
}

const initialState: DevicesState = {
  devices: [],
  loading: false,
  error: null,
};

export const useDevicesStore = create<DevicesState & DevicesActions>()(
  (set) => ({
    ...initialState,

    setDevices: (devices: DeviceDto[]) => {
      set({ devices, loading: false, error: null });
    },

    setLoading: (loading: boolean) => {
      set({ loading });
    },

    setError: (error: string | null) => {
      set({ error, loading: false });
    },

    clearDevices: () => {
      set({ ...initialState });
    },
  }),
);
